import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/arcsine/cdf';
import __var_2__ from '@stdlib/stats/base/dists/arcsine/ctor';
import __var_3__ from '@stdlib/stats/base/dists/arcsine/entropy';
import __var_4__ from '@stdlib/stats/base/dists/arcsine/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/arcsine/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/arcsine/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/arcsine/mean';
import __var_8__ from '@stdlib/stats/base/dists/arcsine/median';
import __var_9__ from '@stdlib/stats/base/dists/arcsine/mode';
import __var_10__ from '@stdlib/stats/base/dists/arcsine/pdf';
import __var_11__ from '@stdlib/stats/base/dists/arcsine/quantile';
import __var_12__ from '@stdlib/stats/base/dists/arcsine/skewness';
import __var_13__ from '@stdlib/stats/base/dists/arcsine/stdev';
import __var_14__ from '@stdlib/stats/base/dists/arcsine/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace arcsine
*/
var arcsine = {};

/**
* @name cdf
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/cdf}
*/
setReadOnly( arcsine, 'cdf', __var_1__);

/**
* @name Arcsine
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/ctor}
*/
setReadOnly( arcsine, 'Arcsine', __var_2__);

/**
* @name entropy
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/entropy}
*/
setReadOnly( arcsine, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/kurtosis}
*/
setReadOnly( arcsine, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/logcdf}
*/
setReadOnly( arcsine, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/logpdf}
*/
setReadOnly( arcsine, 'logpdf', __var_6__);

/**
* @name mean
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/mean}
*/
setReadOnly( arcsine, 'mean', __var_7__);

/**
* @name median
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/median}
*/
setReadOnly( arcsine, 'median', __var_8__);

/**
* @name mode
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/mode}
*/
setReadOnly( arcsine, 'mode', __var_9__);

/**
* @name pdf
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/pdf}
*/
setReadOnly( arcsine, 'pdf', __var_10__);

/**
* @name quantile
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/quantile}
*/
setReadOnly( arcsine, 'quantile', __var_11__);

/**
* @name skewness
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/skewness}
*/
setReadOnly( arcsine, 'skewness', __var_12__);

/**
* @name stdev
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/stdev}
*/
setReadOnly( arcsine, 'stdev', __var_13__);

/**
* @name variance
* @memberof arcsine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/arcsine/variance}
*/
setReadOnly( arcsine, 'variance', __var_14__);


// EXPORTS //
export default arcsine;

export { __var_1__ as cdf, __var_2__ as Arcsine, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mode, __var_10__ as pdf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};